module.exports = __webpack_public_path__ + "media/images/night-sky-51b096abd273b7ddc491b6248c3e974b.png";